import React, {useEffect, useState} from 'react';
import HeaderCmp from "../component/header.cmp";
import "./css/mainPage.css";
import PageGraph from "./graph/page.graph";
import PageEquipage from "./equipage/page.equipage";
import PageBsi from "./bsi/page.bsi";
import {ModuleRegistry} from '@ag-grid-community/core';
import {ClientSideRowModelModule} from '@ag-grid-community/client-side-row-model';
import {StatusBarModule} from '@ag-grid-enterprise/status-bar';
import {MenuModule} from '@ag-grid-enterprise/menu';
import {RowGroupingModule} from '@ag-grid-enterprise/row-grouping';
import {RangeSelectionModule} from '@ag-grid-enterprise/range-selection';
// import {AgGridReact} from '@ag-grid-community/react';
import {RichSelectModule} from '@ag-grid-enterprise/rich-select';
import {ColumnsToolPanelModule} from '@ag-grid-enterprise/column-tool-panel';
import {FiltersToolPanelModule} from '@ag-grid-enterprise/filter-tool-panel';
import {ExcelExportModule} from '@ag-grid-enterprise/excel-export';
import PageReport from "./report/page.report";
import PageLogging from "./logging/page.logging";
import PageCliff from "./cliff/page.cliff";
import PagePPK from "./ppk/page.ppk";
import PageControlRequests from "./controlRequests/page.controlRequests";
import PageEquipageStats from "./equipageStats/page.equipageStats";
import PageValveIssues from "./valveIssues/page.valveIssues";
import PageContractorClosure from "./contractorClosure/page.contractorClosure";
import PageAdminSettings from "./adminSettings/page.adminSettings";
import {canManageAccess, canUseModule} from "../service/authAccess";

const LAST_MENU_ITEM_KEY = 'aspo:lastMenuItem';
const DEFAULT_MENU_ITEM = 'График';
const MENU_BY_HASH: Record<string, string> = {
    '#repairs': 'Ремонты',
    '#equipages': 'Экипажи',
    '#bsi': 'БСИ',
    '#graph': 'График',
    '#cliff': 'Обрывы',
    '#ppk': 'ППК',
    '#control-requests': 'Заявки КС',
    '#valves': 'Задвижки',
    '#contractor-closure': 'Закрытие КА',
    '#reports': 'Отчеты',
    '#logs': 'Логи',
    '#settings': 'Настройки',
};

const PAGE_MODULES: Record<string, string> = {
    'Ремонты': 'repairs',
    'Экипажи': 'equipages',
    'БСИ': 'bsi',
    'График': 'graph',
    'Обрывы': 'cliff',
    'ППК': 'ppk',
    'Заявки КС': 'control_requests',
    'Задвижки': 'valves',
    'Закрытие КА': 'contractor_closure',
    'Отчеты': 'reports',
    'Логи': 'logs',
    'Настройки': 'settings',
};

const canUsePage = (pageName: string | null) => {
    const moduleId = PAGE_MODULES[pageName || ''];
    if (!moduleId) {
        return false;
    }

    if (moduleId === 'settings') {
        return canManageAccess();
    }

    return canUseModule(moduleId);
};

ModuleRegistry.registerModules([ClientSideRowModelModule,
    RangeSelectionModule, RowGroupingModule, RichSelectModule, ColumnsToolPanelModule,
    FiltersToolPanelModule, StatusBarModule, MenuModule, ExcelExportModule]);


ModuleRegistry.registerModules([ExcelExportModule]);

const PageMain = (props: { loading: boolean }) => {
    const [selectedMenuItem, setSelectedMenuItem] = useState<string | null>(() => (
        MENU_BY_HASH[window.location.hash] || localStorage.getItem(LAST_MENU_ITEM_KEY) || DEFAULT_MENU_ITEM
    ));

    useEffect(() => {
        document.title = 'АСПО.Контроль | Главная';
    }, []);

    const handleSelectMenuItem = (menuItem: string | null) => {
        setSelectedMenuItem(menuItem);
        if (menuItem) {
            localStorage.setItem(LAST_MENU_ITEM_KEY, menuItem);
        } else {
            localStorage.removeItem(LAST_MENU_ITEM_KEY);
        }
    };

    useEffect(() => {
        if (!canUsePage(selectedMenuItem)) {
            handleSelectMenuItem(DEFAULT_MENU_ITEM);
            window.location.hash = '#graph';
        }
    }, [selectedMenuItem]);

    useEffect(() => {
        const handleHashChange = () => {
            const menuItem = MENU_BY_HASH[window.location.hash];
            if (menuItem) {
                handleSelectMenuItem(menuItem);
            }
        };

        window.addEventListener('hashchange', handleHashChange);
        return () => window.removeEventListener('hashchange', handleHashChange);
    }, []);

    return (
        <>
            {!props.loading && <HeaderCmp selectedMenuItem={selectedMenuItem} setSelectedMenuItem={handleSelectMenuItem}/>}
            {selectedMenuItem === "БСИ" && <PageBsi/>}
            {selectedMenuItem === "График" && <PageGraph/>}
            {selectedMenuItem === "Ремонты" && <PageEquipage/>}
            {selectedMenuItem === "Экипажи" && <PageEquipageStats/>}
            {selectedMenuItem === "Обрывы" && <PageCliff/>}
            {selectedMenuItem === "ППК" && <PagePPK/>}
            {selectedMenuItem === "Заявки КС" && <PageControlRequests/>}
            {selectedMenuItem === "Задвижки" && <PageValveIssues/>}
            {selectedMenuItem === "Закрытие КА" && <PageContractorClosure/>}
            {selectedMenuItem === "Отчеты" && <PageReport/>}
            {selectedMenuItem === "Логи" && <PageLogging/>}
            {selectedMenuItem === "Настройки" && <PageAdminSettings/>}

        </>
    );
}

export default PageMain;
